import { render, staticRenderFns } from "./MyPopover.vue?vue&type=template&id=554fb16f&scoped=true&"
import script from "./MyPopover.vue?vue&type=script&lang=js&"
export * from "./MyPopover.vue?vue&type=script&lang=js&"
import style0 from "./MyPopover.vue?vue&type=style&index=0&id=554fb16f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554fb16f",
  null
  
)

export default component.exports